<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="reviews"
        :loading="loading"
        class="va-table va-table--hoverable va-table--clickable"
        no-data-label="Пусто"
      >
        <template slot="florist" slot-scope="props">
          <span>{{ getFloristName(props.rowData.florist_id) }}</span>
        </template>
        <template slot="reviewer_name" slot-scope="props">
          <span>{{ props.rowData.reviewer_name }}</span>
        </template>
        <template slot="date" slot-scope="props">
          <span>{{ formatDate(props.rowData.date) }}</span>
        </template>
        <template slot="rating" slot-scope="props">
          <span>{{ props.rowData.rating }}/5</span>
        </template>
        <template slot="text" slot-scope="props">
          <span>{{ truncate(props.rowData.text, 50) }}</span>
        </template>
        <template slot="photos" slot-scope="props">
          <span>{{ props.rowData.photos ? props.rowData.photos.length : 0 }} фото</span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-pencil"
            @click.stop="updateHandler(props.rowData)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-trash"
            @click.stop="removeHandler(props.rowData.id)"
          />
        </template>
      </va-data-table>
    </va-card>
    <va-modal v-model="updateModal" size="large" hide-default-actions>
      <florist-review-update
        :review="currentReview"
        :florists="florists"
        @close="updateModal = false"
        @updated="handleUpdated"
      />
    </va-modal>
  </div>
</template>

<script>
import api from '@/api/axios';
import FloristReviewUpdate from './florist-review-update.vue';

export default {
  components: { FloristReviewUpdate },
  props: {
    reviews: {
      type: Array,
      require: true,
      default: () => [],
    },
    florists: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      updateModal: false,
      currentReview: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:florist',
          title: 'Флорист',
        },
        {
          name: '__slot:reviewer_name',
          title: 'Имя ревьюера',
        },
        {
          name: '__slot:date',
          title: 'Дата',
        },
        {
          name: '__slot:rating',
          title: 'Рейтинг',
          width: '100px',
        },
        {
          name: '__slot:text',
          title: 'Текст',
        },
        {
          name: '__slot:photos',
          title: 'Фото',
          width: '100px',
        },
        {
          name: '__slot:actions',
          title: '',
          width: '100px',
        },
      ];
    },
  },
  methods: {
    getFloristName(floristId) {
      const florist = this.florists.find((f) => f.id === floristId);
      return florist ? florist.name : '-';
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleDateString('ru-RU', { timeZone: 'Asia/Omsk' });
    },
    truncate(value, size) {
      if (!value) return '-';
      value = value.toString();
      if (value.length <= size) {
        return value;
      }
      return value.substr(0, size) + '...';
    },
    updateHandler(review) {
      this.updateModal = true;
      this.currentReview = review;
    },
    handleUpdated() {
      this.updateModal = false;
      this.$emit('refresh');
    },
    async removeHandler(id) {
      if (confirm('Вы действительно хотите удалить отзыв?')) {
        try {
          await api.delete(`/admin/florist-reviews/${id}`);
          this.$emit('refresh');
        } catch (error) {
          console.error('Ошибка удаления отзыва:', error);
          alert('Ошибка при удалении отзыва');
        }
      }
    },
  },
};
</script>

<style></style>

